import { PriorityPlaylist } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import unassignedTasksPlaybookImage from '@backrs_ui/grow-ui/src/assets/images/priorities/unassigned-tasks-playbook.svg';

/** The default playlist can't be renamed or deleted. */
export const isLockedPlaylist = (playlist: PriorityPlaylist): boolean => !!playlist.is_default;

/** The default playlist's bundled sticker art, used when no image was uploaded. */
export const usesBundledArtwork = (playlist: PriorityPlaylist): boolean =>
  !!playlist.is_default && !playlist.preview_media?.media_url;

export const getPlaylistImageUrl = (playlist: PriorityPlaylist): string | undefined =>
  usesBundledArtwork(playlist) ? unassignedTasksPlaybookImage : playlist.preview_media?.media_url;

export const getPlaybookPath = (playlistId: number): string =>
  APP_ROUTE.PLAYBOOK.replace(':playbookId', String(playlistId));

// Not `playbook`: that key is PageShell's suggested-playlist deep link on every route.
export const TEMPLATE_PLAYBOOK_QUERY_KEY = 'template-playbook';

// A template's tasks aren't the viewer's, so the task page resolves them through the template playbook instead of by id alone.
export const getPlaybookTaskPath = (taskId: number, templatePlaylistId?: number): string => {
  const path = APP_ROUTE.PLAYBOOK_TASK.replace(':taskId', String(taskId));

  return templatePlaylistId ? `${path}?${TEMPLATE_PLAYBOOK_QUERY_KEY}=${templatePlaylistId}` : path;
};

export const getPlaylistPercentageFilled = (playlist: PriorityPlaylist): number =>
  !!playlist.completed_tasks && !!playlist.total_tasks
    ? (playlist.completed_tasks / playlist.total_tasks) * 100
    : 0;

export const sortDefaultPlaylistFirst = (playlists: PriorityPlaylist[]): PriorityPlaylist[] =>
  [...playlists].sort((a, b) => Number(!!b.is_default) - Number(!!a.is_default));

export const handlePlaylistSearch = (
  playlists: PriorityPlaylist[],
  searchTerm: string,
): PriorityPlaylist[] => {
  if (searchTerm.length === 0) {
    return playlists;
  }

  const searchLower = searchTerm.toLowerCase();

  return playlists.filter((playlist) => {
    const searchableText = [
      playlist.title,
      playlist.description,
      playlist.marketing_description,
      playlist.keywords,
      ...(playlist.tags?.map((tag) => tag.title) ?? []),
    ]
      .join(' ')
      .toLowerCase();

    return searchableText.includes(searchLower);
  });
};
